import { render, staticRenderFns } from "./TheNote.vue?vue&type=template&id=dfd625ea&scoped=true&"
import script from "./TheNote.vue?vue&type=script&lang=js&"
export * from "./TheNote.vue?vue&type=script&lang=js&"
import style0 from "./TheNote.vue?vue&type=style&index=0&id=dfd625ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd625ea",
  null
  
)

export default component.exports